export default {
  // Inventory
  "inventory": "インベントリ",
  "cameras": "カメラ",
  "lenses": "レンズ",
  "film": "フィルム",
  "add_camera": "カメラを追加",
  "add_lens": "レンズを追加",
  "add_film": "フィルムを追加",
  "no_cameras": "カメラがありません",
  "no_lenses": "レンズがありません",
  "no_film": "フィルムがありません",
  "add_first_camera": "最初のカメラを追加",
  "add_first_lens": "最初のレンズを追加",
  "add_first_film": "最初のフィルムを追加",
  "search_cameras": "カメラを検索",
  "search_lenses": "レンズを検索",
  "search_film": "フィルムを検索",
  "brand": "ブランド",
  "model": "モデル",
  "type": "タイプ",
  "format": "フォーマット",
  "mount": "マウント",
  "focal_length": "焦点距離",
  "aperture": "絞り",
  "notes": "メモ",
  "add_notes": "メモを追加",
  "iso": "ISO",
  "color": "カラー",
  "black_white": "白黒",
  "expired": "期限切れ",
  "expiration_date": "有効期限",
  "film_stock": "フィルムストック",
  "frames": "フレーム数",
  "frames_remaining": "残りフレーム数",
  "development": "現像",
  "camera_details": "カメラ詳細",
  "lens_details": "レンズ詳細",
  "compatible_cameras": "互換性のあるカメラ",
  "compatible_lenses": "互換性のあるレンズ",
  "compatible_film": "互換性のあるフィルム",
  "adapters": "アダプター",
  "status": "ステータス",
  "new": "新品",
  "used": "使用済み",
  "in_development": "現像中",
  "developed": "現像済み",
  "archived": "アーカイブ",
  "all": "すべて",
  "transfer_film": "フィルムを転送",
  "transfer_to_camera": "カメラに転送",
  "select_camera": "カメラを選択",
  "set_frames_remaining": "残りフレーム数を設定",
  "date_added": "追加日",
  "date_modified": "更新日",
  "edit_camera": "カメラを編集",
  "edit_lens": "レンズを編集",
  "edit_film": "フィルムを編集",
  "delete_camera": "カメラを削除",
  "delete_lens": "レンズを削除",
  "delete_film": "フィルムを削除",
  "confirmation": "確認",
  "delete_confirmation": "本当に削除しますか？このアクションは元に戻せません。",
  "camera_type": "カメラタイプ",
  "medium_format": "中判",
  "large_format": "大判",
  "no_films_yet": "まだフィルムロールがありません",
};
